import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import InputMask from "react-input-mask";
import { API_BASE_URL } from "./config";
import { ToastContainer, toast } from "react-toastify";
import { Form, Row, Col, Button, Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import './modal.css'

const isTechnicalServerMessage = (value) => {
    if (!value) return false;

    const normalizedValue = String(value).toLowerCase();

    return (
        normalizedValue.includes("<!doctype") ||
        normalizedValue.includes("<html") ||
        normalizedValue.includes("<body") ||
        normalizedValue.includes("<pre>") ||
        normalizedValue.includes("query.then") ||
        normalizedValue.includes("node_modules") ||
        normalizedValue.includes("mysql2") ||
        normalizedValue.includes("stack") ||
        normalizedValue.includes("error:")
    );
};

const getMatriculaErrorMessage = (error) => {
    const responseData = error?.response?.data;
    const rawMessage =
        typeof responseData === "string"
            ? responseData
            : (responseData?.msg || responseData?.message || responseData?.error || "");

    if (rawMessage && !isTechnicalServerMessage(rawMessage)) {
        return rawMessage;
    }

    if (rawMessage && isTechnicalServerMessage(rawMessage)) {
        return "Existem campos obrigatorios nao preenchidos. Revise os campos em vermelho.";
    }

    if (error?.response?.status === 401 || error?.response?.status === 403) {
        return "Sua sessao nao permite cadastrar ou editar matriculas.";
    }

    if (error?.request) {
        return "Nao foi possivel comunicar com o servidor para salvar a matricula.";
    }

    return "Erro ao processar matricula.";
};

const CadastroMatricula = ({
    matriculaId,
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const goBack = () => {
        const from = location.state?.from;
        if (typeof from === "string" && from.startsWith("/")) {
            navigate(from, { replace: true });
            return;
        }
        navigate("/matriculas");
    };
    const isValidCourseName = (name) => {
        if (name === null || name === undefined) return false;
        const normalizedName = String(name).trim();
        if (!normalizedName) return false;

        const lowered = normalizedName.toLowerCase();
        return lowered !== "null" && lowered !== "undefined";
    };

    const [usuarios, setUsuarios] = useState([]);
    const [dadosUsuario, setDadosUsuario] = useState({});
    const [cursos, setCursos] = useState([]);
    const [escolas, setEscolas] = useState([]);
    const [showAdditionalFields, setShowAdditionalFields] = useState(false);
    const [showParentFields, setShowParentFields] = useState(false);
    const [filteredUsuarios, setFilteredUsuarios] = useState([]);
    const [showUserSearchModal, setShowUserSearchModal] = useState(false);
    const inputSearchRef = useRef(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [acaoConfirmada, setAcaoConfirmada] = useState(null);
    const [showPaymentChangeModal, setShowPaymentChangeModal] = useState(false);
    const [pendingPaymentType, setPendingPaymentType] = useState("");
    const [nomeEscola, setNomeEscola] = useState(""); // Novo estado para o nome da escola
    const [originalStatus, setOriginalStatus] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});

    const abrirModalConfirmacao = () => setShowConfirmModal(true);
    const fecharModalConfirmacao = () => setShowConfirmModal(false);


    // const [usuarioSelecionado, setUsuarioSelecionado] = useState();
    const [matriculaData, setMatriculaData] = useState({
        status: "ativo",
        numeroParcelas: "",
        valorParcela: 0,
        usuarioId: "",
        nomeUsuario: "",
        cpfUsuario: "",
        valorCurso: "",
        cursoId: "",
        escolaId: "",
        dataNascimento: "",
        profissao: "",
        estadoCivil: "",
        endereco: "",
        rua: "",
        numero: "",
        whatsapp: "",
        telefone: "",
        email: "",
        escolaridade: "",
        localNascimento: "",
        redeSocial: "",
        nomePai: "",
        contatoPai: "",
        nomeMae: "",
        contatoMae: "",
        horarioInicio: "",
        horarioFim: "",
        nivelIdioma: "",
        primeiraDataPagamento: "",
        tipoPagamento: "parcelado",
        valorMensalidade: "",
        modoCurso: "60h",
    });

    const limparCampos = () => {
        setMatriculaData({
            status: "ativo",
            numeroParcelas: "",
            valorParcela: "",
            usuarioId: "",
            nomeUsuario: "",
            cpfUsuario: "",
            valorCurso: "",
            cursoId: "",
            escolaId: "",
            dataNascimento: "",
            profissao: "",
            estadoCivil: "",
            endereco: "",
            rua: "",
            numero: "",
            whatsapp: "",
            telefone: "",
            email: "",
            escolaridade: "",
            localNascimento: "",
            redeSocial: "",
            nomePai: "",
            contatoPai: "",
            nomeMae: "",
            contatoMae: "",
            horarioInicio: "",
            horarioFim: "",
            nivelIdioma: "",
            primeiraDataPagamento: "",
            tipoPagamento: "parcelado",
            valorMensalidade: "",
            modoCurso: "60h",
        });
        setFieldErrors({});
    };

    const parseValorMonetario = (valor) => {
        if (valor === null || valor === undefined || valor === "") return NaN;
        if (typeof valor === "number") return Number.isFinite(valor) ? valor : NaN;

        const valorString = String(valor).trim().replace(/\s+/g, "").replace(/[^\d,.-]/g, "");
        if (!valorString) return NaN;

        const negativo = valorString.startsWith("-");
        const valorSemSinal = valorString.replace(/-/g, "");
        if (!valorSemSinal) return NaN;

        const temVirgula = valorSemSinal.includes(",");
        const temPonto = valorSemSinal.includes(".");
        let parteInteira = "";
        let parteDecimal;

        if (temVirgula && temPonto) {
            const [p0, p1] = valorSemSinal.split(",");
            parteInteira = (p0 || "").replace(/\./g, "");
            parteDecimal = p1;
        } else if (temVirgula) {
            const [p0, p1] = valorSemSinal.split(",");
            parteInteira = (p0 || "").replace(/\./g, "");
            parteDecimal = p1;
        } else if (temPonto) {
            const dotParts = valorSemSinal.split(".");
            const last = dotParts[dotParts.length - 1] || "";
            const pontoEhDecimal = last.length <= 2;
            if (pontoEhDecimal) {
                parteInteira = dotParts.slice(0, -1).join("").replace(/,/g, "");
                parteDecimal = last;
            } else {
                parteInteira = valorSemSinal.replace(/\./g, "").replace(/,/g, "");
                parteDecimal = undefined;
            }
        } else {
            parteInteira = valorSemSinal;
            parteDecimal = undefined;
        }

        const valorNormalizado = `${negativo ? "-" : ""}${parteInteira}${parteDecimal !== undefined ? `.${parteDecimal}` : ""}`;
        const numero = Number.parseFloat(valorNormalizado);

        return Number.isFinite(numero) ? numero : NaN;
    };

    const formatarValorMonetario = (valor) => {
        const numero = parseValorMonetario(valor);
        if (!Number.isFinite(numero)) return "";

        return numero.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const parseNumeroParcelas = (valor) => {
        if (valor === null || valor === undefined || valor === "") return NaN;

        const valorLimpo = String(valor).replace(/\D/g, "");
        if (!valorLimpo) return NaN;

        return parseInt(valorLimpo, 10);
    };

    const calcularValorParcelaNumerico = (valorCursoInput, numeroParcelasInput) => {
        const valorCurso = parseValorMonetario(valorCursoInput);
        const numeroParcelas = parseNumeroParcelas(numeroParcelasInput);

        if (!Number.isFinite(valorCurso) || !Number.isFinite(numeroParcelas) || numeroParcelas <= 0) {
            return NaN;
        }

        return valorCurso / numeroParcelas;
    };

    const buscarDadosUsuario = (usuarioId) => {
        axios.get(`${API_BASE_URL}/matricula/${usuarioId}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
            .then(response => {
                if (response.data) {
                    setDadosUsuario(response.data); // Atualiza os dados do usuário

                    setMatriculaData(prevMatriculaData => ({
                        ...prevMatriculaData,
                        usuarioId: usuarioId, // Garante que o usuário seja identificado corretamente
                        nomeUsuario: response.data.nomeUsuario || "",
                        cpfUsuario: response.data.cpfUsuario || "",
                        dataNascimento: formatarData(response.data.dataNascimento) || "",
                        profissao: response.data.profissao || "",
                        estadoCivil: response.data.estadoCivil || "Não informado",
                        endereco: response.data.endereco || "",
                        whatsapp: response.data.whatsapp || "",
                        telefone: response.data.telefone || "",
                        email: response.data.email || "",
                        escolaId: response.data.escolaId || "",
                    }));

                } else {
                    toast.error("Usuário não encontrado.");
                }
            })
            .catch(error => {
                console.error("Erro ao buscar usuário:", error);
                toast.error("Erro ao buscar usuário.");
            });
    };



    useEffect(() => {
        if (showUserSearchModal && inputSearchRef.current) {
            inputSearchRef.current.focus();
        }
    }, [showUserSearchModal]);

    // Funções para abrir e fechar o modal
    const openUserSearchModal = () => {
        setFilteredUsuarios(usuarios); // Preenche a lista antes de abrir o modal
        setShowUserSearchModal(true);
    };

    const closeUserSearchModal = () => setShowUserSearchModal(false);

    useEffect(() => {
        if (!matriculaId) {
            axios
                .get(`${API_BASE_URL}/buscarusermatricula`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                })
                .then((response) => {
                    const schoolId = localStorage.getItem("schoolId");

                    const usuariosFiltrados = response.data.filter(usuario =>
                        usuario.cp_excluido !== 1 && usuario.cp_escola_id == schoolId
                    );

                    setUsuarios(usuariosFiltrados);
                    setFilteredUsuarios(usuariosFiltrados);
                })
                .catch((error) => {
                    console.error("Erro ao buscar usuários:", error);
                });
        }
    }, [matriculaId]);

    const calcularValorParcela = () => {
        const valorParcelaCalculado = calcularValorParcelaNumerico(
            matriculaData.valorCurso,
            matriculaData.numeroParcelas
        );

        const proximoValorParcela = Number.isFinite(valorParcelaCalculado)
            ? Number(valorParcelaCalculado.toFixed(2))
            : 0;

        setMatriculaData((prevData) => {
            const valorAnterior = Number(Number(prevData.valorParcela || 0).toFixed(2));
            const valorAtualizado = Number(Number(proximoValorParcela || 0).toFixed(2));

            if (valorAnterior === valorAtualizado) {
                return prevData;
            }

            return {
                ...prevData,
                valorParcela: proximoValorParcela,
            };
        });
    };

    useEffect(() => {
        calcularValorParcela();
    }, [matriculaData.valorCurso, matriculaData.numeroParcelas]);

    useEffect(() => {
        if (matriculaId) {
            axios.get(`${API_BASE_URL}/matriculas/${matriculaId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            })
                .then(response => {
                    if (response.data) {
                        const dadosMatricula = response.data;
                        setOriginalStatus(dadosMatricula.cp_status_matricula || null);
                        const numeroParcelas = parseNumeroParcelas(dadosMatricula.cp_mt_quantas_parcelas);
                        const valorParcelaApi = parseValorMonetario(
                            dadosMatricula.cp_mt_valor_parcela ?? dadosMatricula.valorParcela
                        );
                        const valorParcelaCalculado = calcularValorParcelaNumerico(
                            dadosMatricula.cp_mt_valor_curso,
                            numeroParcelas
                        );
                        const valorParcelaFinal = Number.isFinite(valorParcelaApi) && valorParcelaApi > 0
                            ? valorParcelaApi
                            : valorParcelaCalculado;

                        setMatriculaData(prevData => ({
                            ...prevData,
                            cursoId: dadosMatricula.cp_mt_curso,
                            escolaId: dadosMatricula.cp_mt_escola,
                            usuarioId: dadosMatricula.cp_mt_usuario,
                            nomeUsuario: dadosMatricula.cp_mt_nome_usuario,
                            cpfUsuario: dadosMatricula.cp_mt_cadastro_usuario,
                            valorCurso: formatarValorMonetario(dadosMatricula.cp_mt_valor_curso),
                            numeroParcelas: Number.isFinite(numeroParcelas) ? String(numeroParcelas) : "",
                            valorParcela: Number.isFinite(valorParcelaFinal) ? Number(valorParcelaFinal.toFixed(2)) : 0,
                            primeiraDataPagamento: formatarDataParaExibicao(dadosMatricula.cp_mt_primeira_parcela),
                            status: dadosMatricula.cp_status_matricula,
                            nivelIdioma: dadosMatricula.cp_mt_nivel,
                            horarioInicio: dadosMatricula.cp_mt_horario_inicio,
                            horarioFim: dadosMatricula.cp_mt_horario_fim,
                            escolaridade: dadosMatricula.cp_mt_escolaridade,
                            localNascimento: dadosMatricula.cp_mt_local_nascimento,
                            redeSocial: dadosMatricula.cp_mt_rede_social,
                            nomePai: dadosMatricula.cp_mt_nome_pai,
                            contatoPai: dadosMatricula.cp_mt_contato_pai,
                            nomeMae: dadosMatricula.cp_mt_nome_mae,
                            contatoMae: dadosMatricula.cp_mt_contato_mae,
                            tipoPagamento: dadosMatricula.cp_mt_tipo_pagamento || "parcelado",
                            valorMensalidade: dadosMatricula.cp_mt_valor_mensalidade || "",
                            modoCurso: dadosMatricula.cp_mt_modo_curso || "60h",
                        }));

                        // Buscar os dados do usuário vinculado à matrícula
                        if (dadosMatricula.cp_mt_usuario) {
                            buscarDadosUsuario(dadosMatricula.cp_mt_usuario);
                        }
                    } else {
                        toast.error("Matrícula não encontrada.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao buscar matrícula:", error);
                    toast.error("Erro ao buscar matrícula.");
                });
        }
    }, [matriculaId]);



    const loadDefaultLanguageLevels = () => {
        return [
            { id: "basico", nome: "Básico" },
            { id: "intermediario", nome: "Intermediário" },
            { id: "avancado", nome: "Avançado" },
        ];
    };



    const defaultLanguageLevels = loadDefaultLanguageLevels();

    const formatarDataParaExibicao = (dataString) => {
        if (!dataString) return "";
        // Se já estiver em dd/mm/yyyy, retorna
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataString)) return dataString;
        
        // Tenta processar yyyy-mm-dd (com ou sem hora)
        if (typeof dataString === 'string' && dataString.includes('-')) {
             const datePart = dataString.split('T')[0];
             const [ano, mes, dia] = datePart.split('-');
             return `${dia}/${mes}/${ano}`;
        }
        
        return "";
    };

    const formatarDataParaEnvio = (dataString) => {
        if (!dataString) return null;
        // Espera formato dd/mm/yyyy
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataString)) {
            const [dia, mes, ano] = dataString.split('/');
            return `${ano}-${mes}-${dia}`;
        }
        // Se já estiver em yyyy-mm-dd, retorna
        if (/^\d{4}-\d{2}-\d{2}$/.test(dataString)) return dataString;

        return null;
    };

    const clearFieldError = (...fieldNames) => {
        if (!fieldNames.length) return;

        setFieldErrors((prevErrors) => {
            const nextErrors = { ...prevErrors };
            fieldNames.forEach((fieldName) => {
                delete nextErrors[fieldName];
            });
            return nextErrors;
        });
    };

    const getFieldClassName = (fieldName, baseClassName = "form-control") => (
        fieldErrors[fieldName] ? `${baseClassName} is-invalid` : baseClassName
    );

    const getFieldStyle = (fieldName) => (
        fieldErrors[fieldName]
            ? {
                borderColor: "#dc3545",
                paddingRight: "calc(1.5em + 0.75rem)",
                backgroundImage: "none",
            }
            : undefined
    );

    const validateRequiredFields = (primeiraDataPagamento, valorPrincipalNumerico, mensalidadeNumerica) => {
        const nextErrors = {};

        if (!matriculaData.usuarioId) {
            nextErrors.nomeUsuario = "Selecione um aluno.";
        }

        if (!matriculaData.cursoId) {
            nextErrors.cursoId = "Selecione um curso.";
        }

        if (!primeiraDataPagamento) {
            nextErrors.primeiraParcela = "Informe a data da primeira parcela.";
        }

        if (!Number.isFinite(valorPrincipalNumerico) || valorPrincipalNumerico <= 0) {
            nextErrors.valorCurso =
                matriculaData.tipoPagamento === "mensalidade"
                    ? "Informe um valor valido para a mensalidade."
                    : "Informe um valor valido para o curso.";
        }

        if (matriculaData.tipoPagamento === "parcelado" && !matriculaData.numeroParcelas) {
            nextErrors.numeroParcelas = "Selecione o numero de parcelas.";
        }

        if (
            matriculaData.tipoPagamento === "mensalidade" &&
            (!Number.isFinite(mensalidadeNumerica) || mensalidadeNumerica <= 0)
        ) {
            nextErrors.valorCurso = "Informe um valor valido para a mensalidade.";
        }

        return nextErrors;
    };

    const handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();

        const primeiraDataPagamento = formatarDataParaEnvio(matriculaData.primeiraDataPagamento);
        const valorPrincipal = matriculaData.valorCurso;
        const valorMensalidade = matriculaData.tipoPagamento === "mensalidade"
            ? (matriculaData.valorMensalidade || valorPrincipal)
            : null;
        const valorPrincipalNumerico = parseValorMonetario(valorPrincipal);

        const statusChanged =
            Boolean(matriculaId) &&
            originalStatus !== null &&
            String(originalStatus).toLowerCase() !== String(matriculaData.status || "").toLowerCase();

        const mensalidadeNumerica =
            matriculaData.tipoPagamento === "mensalidade" ? parseValorMonetario(valorMensalidade) : null;

        const missingForFullEdit =
            !matriculaData.usuarioId ||
            !matriculaData.cursoId ||
            !primeiraDataPagamento ||
            !Number.isFinite(valorPrincipalNumerico) ||
            valorPrincipalNumerico <= 0 ||
            (matriculaData.tipoPagamento === "parcelado" && !matriculaData.numeroParcelas) ||
            (matriculaData.tipoPagamento === "mensalidade" && (!Number.isFinite(mensalidadeNumerica) || mensalidadeNumerica <= 0));

        if (statusChanged && missingForFullEdit) {
            try {
                await axios.put(
                    `${API_BASE_URL}/editar-matricula/${matriculaId}`,
                    { status: matriculaData.status },
                    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
                );
                setOriginalStatus(matriculaData.status);
                toast.success("Status da matrícula atualizado com sucesso");
                return;
            } catch (error) {
                toast.error(getMatriculaErrorMessage(error));
                return;
            }
        }

        const validationErrors = validateRequiredFields(
            primeiraDataPagamento,
            valorPrincipalNumerico,
            mensalidadeNumerica
        );

        setFieldErrors(validationErrors);

        if (!matriculaData.usuarioId) {
            toast.error("Selecione um aluno para cadastrar a matricula.");
            return;
        }

        if (!matriculaData.cursoId) {
            toast.error("Selecione um curso para cadastrar a matricula.");
            return;
        }

        if (!primeiraDataPagamento) {
            toast.error("Informe uma data valida para a primeira parcela no formato dd/mm/aaaa.");
            return;
        }

        if (!Number.isFinite(valorPrincipalNumerico) || valorPrincipalNumerico <= 0) {
            toast.error(
                matriculaData.tipoPagamento === "mensalidade"
                    ? "Informe um valor valido para a mensalidade."
                    : "Informe um valor valido para o curso."
            );
            return;
        }

        if (matriculaData.tipoPagamento === "parcelado" && !matriculaData.numeroParcelas) {
            toast.error("Selecione o numero de parcelas.");
            return;
        }

        try {
            // Removido formatarData local antigo pois não suporta dd/mm/yyyy corretamente

            if (matriculaId) {
                const editObj = {
                    cursoId: matriculaData.cursoId,
                    usuarioId: matriculaData.usuarioId,
                    escolaId: matriculaData.escolaId,
                    nomeUsuario: matriculaData.nomeUsuario,
                    cpfUsuario: matriculaData.cpfUsuario,
                    valorCurso: valorPrincipal,
                    numeroParcelas: matriculaData.tipoPagamento === "parcelado" ? matriculaData.numeroParcelas : null,
                    valorParcela: matriculaData.tipoPagamento === "parcelado" ? matriculaData.valorParcela : null,
                    primeiraDataPagamento,
                    status: matriculaData.status,
                    nivelIdioma: matriculaData.nivelIdioma,
                    horarioInicio: matriculaData.horarioInicio,
                    horarioFim: matriculaData.horarioFim,
                    localNascimento: matriculaData.localNascimento,
                    escolaridade: matriculaData.escolaridade,
                    redeSocial: matriculaData.redeSocial,
                    nomePai: matriculaData.nomePai,
                    contatoPai: matriculaData.contatoPai,
                    nomeMae: matriculaData.nomeMae,
                    contatoMae: matriculaData.contatoMae,
                    tipoPagamento: matriculaData.tipoPagamento,
                    diasSemana: matriculaData.diasSemana || null,
                    valorMensalidade,
                    modoCurso: matriculaData.modoCurso,
                };

                await axios.put(`${API_BASE_URL}/editar-matricula/${matriculaId}`, editObj, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                });
                toast.success("Matrícula editada com sucesso");
                goBack();
            } else {
                const createObj = {
                    ...matriculaData,
                    numeroParcelas: matriculaData.tipoPagamento === "parcelado" ? matriculaData.numeroParcelas : null,
                    valorParcela: matriculaData.tipoPagamento === "parcelado" ? matriculaData.valorParcela : null,
                    valorCurso: valorPrincipal,
                    valorMensalidade,
                    primeiraDataPagamento,
                };

                const response = await axios.post(`${API_BASE_URL}/cadastrar-matricula`, createObj, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                });
                if (response.data?.msg === "Matrícula cadastrada com sucesso") {
                    toast.success("Matrícula cadastrada com sucesso");
                    limparCampos();
                    goBack();
                } else {
                    toast.error("Erro ao cadastrar matrícula");
                }
            }
        } catch (error) {
            console.error("Erro ao processar matricula:", {
                message: error?.message || null,
                status: error?.response?.status || null,
                responseData: error?.response?.data || null,
                requestData: error?.config?.data || null,
                url: error?.config?.url || null,
                error,
            });
            toast.error(getMatriculaErrorMessage(error));
        }
    };




    const handleUsuarioChange = (e) => {
        const selectedUserId = e.target.value;

        if (selectedUserId) {
            axios.get(`${API_BASE_URL}/buscarusermatricula/${selectedUserId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            })
                .then(response => {
                    if (response.data) {
                        const usuario = response.data;
                        setDadosUsuario(usuario);

                        setMatriculaData(prevMatriculaData => ({
                            ...prevMatriculaData,
                            usuarioId: usuario.cp_id,
                            nomeUsuario: usuario.cp_nome,
                            cpfUsuario: usuario.cp_cpf,
                            dataNascimento: usuario.cp_datanascimento,
                            profissao: usuario.cp_profissao,
                            estadoCivil: usuario.cp_estadocivil,
                            endereco: `${usuario.cp_end_cidade_estado}, ${usuario.cp_end_rua}, ${usuario.cp_end_num}`,
                            whatsapp: usuario.cp_whatsapp,
                            telefone: usuario.cp_telefone,
                            email: usuario.cp_email,
                            // escolaridade: usuario.cp_escolaridade,
                            escolaId: usuario.cp_escola_id
                        }));
                    } else {
                        console.error("Usuário não encontrado:", response.data);
                        toast.error("Usuário não encontrado");
                    }
                })
                .catch(error => {
                    console.error("Erro ao buscar dados do usuário:", error);
                    toast.error("Erro ao buscar dados do usuário");
                });
        } else {
            setDadosUsuario({});
            setMatriculaData({
                ...matriculaData,
                usuarioId: '',
                nomeUsuario: '',
                cpfUsuario: '',
                dataNascimento: '',
                profissao: '',
                estadoCivil: '',
                endereco: '',
                whatsapp: '',
                telefone: '',
                email: '',
                escolaridade: '',
                escolaId: ''
            });
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        // Limitar comprimento do WhatsApp para evitar erro de banco de dados
        let processedValue = value;
        if (name === "whatsapp" && value.length > 20) {
            processedValue = value.substring(0, 20);
        }
        
        setMatriculaData({
            ...matriculaData,
            [name]: processedValue,
        });

        if (processedValue && String(processedValue).trim() !== "") {
            clearFieldError(name);
        }
    };

    const formatarData = (dataString) => {
        if (!dataString) return "";

        // Verifica se a data já está no formato correto
        if (/^\d{4}-\d{2}-\d{2}$/.test(dataString)) {
            return dataString;
        }

        const data = new Date(dataString);

        // Se a data for inválida, retorna uma string vazia
        if (isNaN(data.getTime())) return "";

        const ano = data.getFullYear().toString().padStart(4, "0"); // Garante 4 dígitos no ano
        const mes = (data.getMonth() + 1).toString().padStart(2, "0");
        const dia = data.getDate().toString().padStart(2, "0");

        return `${ano}-${mes}-${dia}`; // Retorna no formato YYYY-MM-DD
    };




    const handleNumeroParcelasChange = (e) => {
        const { value } = e.target;
        const numeroParcelas = parseNumeroParcelas(value);
        const valorParcelaCalculado = calcularValorParcelaNumerico(matriculaData.valorCurso, numeroParcelas);

        if (Number.isFinite(numeroParcelas) && numeroParcelas > 0) {
            setMatriculaData((prevMatriculaData) => ({
                ...prevMatriculaData,
                numeroParcelas: String(numeroParcelas),
                valorParcela: Number.isFinite(valorParcelaCalculado) ? Number(valorParcelaCalculado.toFixed(2)) : 0,
            }));
            clearFieldError("numeroParcelas");
        } else {
            setMatriculaData((prevMatriculaData) => ({
                ...prevMatriculaData,
                numeroParcelas: "",
                valorParcela: 0,
            }));
        }
    };

    useEffect(() => {
        fetchCursos();
        fetchEscolas();
    }, []);

    const fetchCursos = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/cursos`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            if (Array.isArray(response.data)) {
                const cursosValidos = response.data
                    .filter((curso) => isValidCourseName(curso?.cp_nome_curso))
                    .map((curso) => ({
                        ...curso,
                        cp_nome_curso: String(curso.cp_nome_curso).trim(),
                    }));

                setCursos(cursosValidos);
                setMatriculaData((prevData) => {
                    const hasSelectedCourse = prevData.cursoId !== null && prevData.cursoId !== undefined && prevData.cursoId !== "";
                    if (!hasSelectedCourse) return prevData;

                    const cursoSelecionadoEhValido = cursosValidos.some(
                        (curso) => String(curso.cp_curso_id) === String(prevData.cursoId)
                    );

                    if (cursoSelecionadoEhValido) return prevData;
                    return { ...prevData, cursoId: "" };
                });
            } else {
                console.error(
                    "Formato de resposta inválido para cursos:",
                    response.data
                );
                toast.error("Formato de resposta inválido para cursos");
            }
        } catch (error) {
            console.error("Erro ao buscar cursos:", error);
            toast.error("Erro ao buscar cursos");
        }
    };

    const fetchEscolas = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/escolas`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            if (Array.isArray(response.data)) {
                setEscolas(response.data);
            } else {
                console.error(
                    "Formato de resposta inválido para escolas:",
                    response.data
                );
                toast.error("Formato de resposta inválido para escolas:");
            }
        } catch (error) {
            console.error("Erro ao buscar escolas:", error);
            toast.error("Erro ao buscar escolas:");
        }
    };

    // UseEffect para atualizar o nome da escola sempre que os dados mudarem
    useEffect(() => {
        // Tenta encontrar o ID da escola em várias fontes possíveis
        const escolaId = matriculaData.escolaId || dadosUsuario.escolaId || dadosUsuario.cp_escola_id;
        
        if (escolaId && escolas.length > 0) {
            // Usa comparação flexível (==) para lidar com string vs number
            const escolaEncontrada = escolas.find(e => e.cp_ec_id == escolaId);
            if (escolaEncontrada) {
                setNomeEscola(escolaEncontrada.cp_ec_nome);
            } else {
                setNomeEscola("");
            }
        } else {
            setNomeEscola("");
        }
    }, [matriculaData.escolaId, dadosUsuario, escolas]);

    const handleParentDataChange = (e) => {
        const isChecked = e.target.checked;
        // Não feche o campo se os valores estiverem em branco
        if (!isChecked) {
            const hasValues =
                matriculaData.nomePai.trim() ||
                matriculaData.contatoPai.trim() ||
                matriculaData.nomeMae.trim() ||
                matriculaData.contatoMae.trim();
            if (hasValues) {
                toast.error("Preencha ou limpe os campos antes de fechar.");
                return;
            }
        }
        setShowParentFields(isChecked);
    };




    const toggleAdditionalFields = () => {
        setShowAdditionalFields(!showAdditionalFields);
    };
    const toggleParentFields = () => {
        setShowParentFields(!showParentFields);
    };

    useEffect(() => {
        const hasParentData =
            matriculaData.nomePai !== "" ||
            matriculaData.contatoPai !== "" ||
            matriculaData.nomeMae !== "" ||
            matriculaData.contatoMae !== "";

        setShowParentFields(hasParentData);
    }, [
        matriculaData.nomePai,
        matriculaData.contatoPai,
        matriculaData.nomeMae,
        matriculaData.contatoMae,
    ]);


    useEffect(() => {
        const hasAdditionalData =
            matriculaData.escolaridade !== "" ||
            matriculaData.localNascimento !== "" ||
            matriculaData.redeSocial !== "";

        setShowAdditionalFields(hasAdditionalData);
    }, [
        matriculaData.escolaridade,
        matriculaData.localNascimento,
        matriculaData.redeSocial,
    ]);

    const handleAdditionalDataChange = (e) => {
        setShowAdditionalFields(e.target.checked);

    };

    const handleUsuarioSearch = (e) => {
        const termoBusca = e.target.value.toLowerCase();
        setMatriculaData((prev) => ({ ...prev, nomeUsuario: e.target.value })); // Atualiza o input de nome

        if (!termoBusca) {
            setFilteredUsuarios(usuarios); // Se vazio, mostra todos
        } else {
            const filtrados = usuarios.filter(usuario =>
                usuario.cp_nome.toLowerCase().includes(termoBusca)
            );
            setFilteredUsuarios(filtrados);
        }

        setShowUserSearchModal(true); // Abre o modal automaticamente
    };



    const handleUsuarioSelect = (usuario) => {
        // Normaliza os dados do usuário para o formato esperado
        const normalizedUser = {
            ...usuario,
            id: usuario.cp_id,
            nomeUsuario: usuario.cp_nome,
            cpfUsuario: usuario.cp_cpf,
            dataNascimento: usuario.cp_datanascimento,
            profissao: usuario.cp_profissao,
            estadoCivil: usuario.cp_estadocivil,
            endereco: [
                usuario.cp_end_cidade_estado,
                usuario.cp_end_rua,
                usuario.cp_end_num
            ].filter(Boolean).join(", "),
            whatsapp: usuario.cp_whatsapp,
            telefone: usuario.cp_telefone,
            email: usuario.cp_email,
            escolaId: usuario.cp_escola_id,
        };

        setDadosUsuario(normalizedUser);
        setMatriculaData(prevMatriculaData => ({
            ...prevMatriculaData,
            usuarioId: normalizedUser.id,
            nomeUsuario: normalizedUser.nomeUsuario,
            cpfUsuario: normalizedUser.cpfUsuario,
            dataNascimento: normalizedUser.dataNascimento,
            profissao: normalizedUser.profissao,
            estadoCivil: normalizedUser.estadoCivil,
            endereco: normalizedUser.endereco,
            whatsapp: normalizedUser.whatsapp,
            telefone: normalizedUser.telefone,
            email: normalizedUser.email,
            escolaId: normalizedUser.escolaId,
        }));
        
        clearFieldError("nomeUsuario");
        closeUserSearchModal(); // Fecha o modal após selecionar
    };

    return (
        <div className="modal-edit">
            <ToastContainer />
            <form className="form-container-cad" onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <div className="card mb-3">
                            <div className="card-header">
                                <h6 className="card-title mb-0">Dados Pessoais</h6>
                            </div>
                            <div className="card-body">
                                <Row className="gy-3">
                                    {matriculaId ? (
                                        // Edição: Apenas exibe os dados sem permitir edição
                                        <Col md={12}>
                                            <label htmlFor="nomeUsuario">Usuário:</label>
                                            <input
                                                type="text"
                                                id="nomeUsuario"
                                                name="nomeUsuario"
                                                value={matriculaData.nomeUsuario || ""}
                                                className={getFieldClassName("nomeUsuario")}
                                                placeholder="Nome do usuário"
                                                required
                                                readOnly
                                            />
                                            {fieldErrors.nomeUsuario && (
                                                <div className="invalid-feedback d-block">{fieldErrors.nomeUsuario}</div>
                                            )}
                                        </Col>
                                    ) : (
                                        // Cadastro: Permite pesquisa ao clicar
                                        <Col md={12}>
                                            <label htmlFor="nomeUsuario">Nome do Usuário:</label>
                                            <input
                                                type="text"
                                                id="nomeUsuario"
                                                name="nomeUsuario"
                                                value={matriculaData.nomeUsuario || ""}
                                                className={getFieldClassName("nomeUsuario", "form-control border-primary text-base")}
                                                placeholder="Clique para pesquisar um aluno"
                                                required
                                                readOnly
                                                onClick={openUserSearchModal}
                                            />
                                            {fieldErrors.nomeUsuario && (
                                                <div className="invalid-feedback d-block">{fieldErrors.nomeUsuario}</div>
                                            )}
                                        </Col>
                                    )}


                                    <Col md={12}>
                                        <label htmlFor="cpfUsuario">CPF do Usuário:</label>
                                        <InputMask
                                            type="text"
                                            id="cpfUsuario"
                                            name="cpfUsuario"
                                            mask="999.999.999-99"
                                            value={matriculaData.cpfUsuario}
                                            className="form-control"
                                            placeholder="CPF"
                                            required
                                            readOnly
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="dataNascimento">Data de Nascimento:</label>
                                        <InputMask
                                            type="text"
                                            id="dataNascimento"
                                            name="dataNascimento"
                                            mask="99/99/9999"
                                            value={formatarDataParaExibicao(dadosUsuario.dataNascimento) || ""}
                                            className="form-control"
                                            readOnly
                                            placeholder="dd/mm/aaaa"
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="profissao">Profissão:</label>
                                        <input
                                            type="text"
                                            id="profissao"
                                            name="profissao"
                                            value={dadosUsuario.profissao || ""}
                                            className="form-control"
                                            placeholder="Profissão"
                                            readOnly
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="estadoCivil">Estado Civil:</label>
                                        <input
                                            type="text"
                                            id="estadoCivil"
                                            name="estadoCivil"
                                            value={dadosUsuario.estadoCivil || "Não informado"}
                                            className="form-control"
                                            placeholder="Estado Civil"
                                            readOnly
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="endereco">Endereço:</label>
                                        <input
                                            type="text"
                                            id="endereco"
                                            name="endereco"
                                            value={`${dadosUsuario.endereco || ""}`}
                                            className="form-control"
                                            placeholder="Endereço"
                                            rows={2}
                                            readOnly
                                        />
                                    </Col>

                                    <Col md={12}>
                                        <label htmlFor="whatsapp">Whatsapp:</label>
                                        <InputMask
                                            mask="(99) 99999-9999"
                                            value={dadosUsuario.whatsapp || ""}
                                            className="form-control"
                                            placeholder="Whatsapp"
                                            readOnly
                                        />
                                    </Col>

                                    <Col md={12}>
                                        <label htmlFor="telefone">Telefone:</label>
                                        <InputMask
                                            mask="(99) 99999-9999"
                                            value={dadosUsuario.telefone || ""}
                                            className="form-control"
                                            placeholder="Telefone"
                                            readOnly
                                        />
                                    </Col>

                                    <Col md={12}>
                                        <label htmlFor="email">Email:</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={dadosUsuario.email || ""}
                                            className="form-control"
                                            placeholder="Email"
                                            readOnly
                                        />
                                    </Col>

                                    <Col md={12}>
                                        <label htmlFor="escolaId">Escola:</label>
                                        <input
                                            type="text"
                                            id="escolaId"
                                            name="escolaId"
                                            value={nomeEscola}
                                            className="form-control"
                                            placeholder="Escola"
                                            readOnly
                                        />
                                    </Col>

                                </Row>
                            </div>
                        </div>

                        <div className="card mb-3 mt-4">
                            <div className="card-header">
                                <h6 className="card-title mb-0">Dados Adicionais</h6>
                            </div>
                            <div className="card-body">
                                <Col md={12}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            id="showAdditionalFields"
                                            name="showAdditionalFields"
                                            checked={showAdditionalFields}
                                            onChange={handleAdditionalDataChange}
                                            className="form-check-input"
                                        />
                                        Exibir Dados Adicionais
                                    </label>
                                </Col>

                                {showAdditionalFields && (
                                    <div className="card mt-3">
                                        <Row className="gy-3">
                                            <Col md={12}>
                                                <label htmlFor="escolaridade">Escolaridade:</label>
                                                <select
                                                    id="escolaridade"
                                                    name="escolaridade"
                                                    value={matriculaData.escolaridade}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                >
                                                    <option value="">Selecione...</option>
                                                    <option value="Ensino Fundamental Incompleto">Ensino Fundamental Incompleto</option>
                                                    <option value="Ensino Fundamental Completo">Ensino Fundamental Completo</option>
                                                    <option value="Ensino Médio Incompleto">Ensino Médio Incompleto</option>
                                                    <option value="Ensino Médio Completo">Ensino Médio Completo</option>
                                                    <option value="Técnico Incompleto">Técnico Incompleto</option>
                                                    <option value="Técnico Completo">Técnico Completo</option>
                                                    <option value="Superior Incompleto">Superior Incompleto</option>
                                                    <option value="Superior Completo">Superior Completo</option>
                                                    <option value="Pós-graduação">Pós-graduação</option>
                                                    <option value="Mestrado">Mestrado</option>
                                                    <option value="Doutorado">Doutorado</option>
                                                    <option value="Outra Graduação">Outra Graduação</option>
                                                </select>
                                            </Col>
                                            <Col md={12}>
                                                <label htmlFor="localNascimento">Local de Nascimento:</label>
                                                <input
                                                    type="text"
                                                    id="localNascimento"
                                                    name="localNascimento"
                                                    value={matriculaData.localNascimento}
                                                    onChange={(e) =>
                                                        setMatriculaData({
                                                            ...matriculaData,
                                                            localNascimento: e.target.value,
                                                        })
                                                    }
                                                    className="form-control"
                                                    placeholder="Local de Nascimento"
                                                />
                                            </Col>
                                            <Col md={12}>
                                                <label htmlFor="redeSocial">Link de Rede Social:</label>
                                                <input
                                                    type="text"
                                                    id="redeSocial"
                                                    name="redeSocial"
                                                    value={matriculaData.redeSocial}
                                                    onChange={(e) =>
                                                        setMatriculaData({
                                                            ...matriculaData,
                                                            redeSocial: e.target.value,
                                                        })
                                                    }
                                                    className="form-control"
                                                    placeholder="Link de Rede Social"
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            </div>
                        </div>

                    </Col>

                    <Col md={6}>
                        <div className="card mb-3">
                            <div className="card-header">
                                <h6 className="card-title mb-0">Dados do Curso</h6>
                            </div>
                            <div className="card-body">
                                <Row className="gy-3">
                                    <Col md={12}>
                                        <label htmlFor="cursoId">Curso:</label>
                                        <select
                                            id="cursoId"
                                            name="cursoId"
                                            value={matriculaData.cursoId}
                                            onChange={(e) => {
                                                setMatriculaData({
                                                    ...matriculaData,
                                                    cursoId: e.target.value,
                                                });

                                                if (e.target.value) {
                                                    clearFieldError("cursoId");
                                                }
                                            }}
                                            className={getFieldClassName("cursoId")}
                                            required
                                        >
                                            <option value="">Selecione o curso</option>
                                            {cursos.map((curso) => (
                                                <option key={curso.cp_curso_id} value={curso.cp_curso_id}>
                                                    {curso.cp_nome_curso}
                                                </option>
                                            ))}
                                        </select>
                                        {fieldErrors.cursoId && (
                                            <div className="invalid-feedback d-block">{fieldErrors.cursoId}</div>
                                        )}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="nivelIdioma">Nível do Idioma:</label>
                                        <select
                                            id="nivelIdioma"
                                            name="nivelIdioma"
                                            value={matriculaData.nivelIdioma}
                                            onChange={(e) =>
                                                setMatriculaData({
                                                    ...matriculaData,
                                                    nivelIdioma: e.target.value,
                                                })
                                            }
                                            className="form-control"
                                        >
                                            <option value="">Selecione o nível do idioma</option>
                                            {defaultLanguageLevels.map((level) => (
                                                <option key={level.id} value={level.nome}>
                                                    {level.nome}
                                                </option>
                                            ))}
                                        </select>
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="horarioInicio">Horário:</label>
                                        <Row>
                                            <Col xs={5}>
                                                <InputMask
                                                    type="text"
                                                    id="horarioInicio"
                                                    name="horarioInicio"
                                                    mask="99:99"
                                                    value={matriculaData.horarioInicio}
                                                    onChange={(e) =>
                                                        setMatriculaData({
                                                            ...matriculaData,
                                                            horarioInicio: e.target.value,
                                                        })
                                                    }
                                                    className="form-control"
                                                    placeholder="Horário de início"
                                                />
                                            </Col>
                                            <Col xs={2}>
                                                <span className="horario-span">até</span>
                                            </Col>
                                            <Col xs={5}>
                                                <InputMask
                                                    type="text"
                                                    id="horarioFim"
                                                    name="horarioFim"
                                                    mask="99:99"
                                                    value={matriculaData.horarioFim}
                                                    onChange={(e) =>
                                                        setMatriculaData({
                                                            ...matriculaData,
                                                            horarioFim: e.target.value,
                                                        })
                                                    }
                                                    className="form-control"
                                                    placeholder="Horário de término"
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="status">Status:</label>
                                        <select
                                            id="status"
                                            name="status"
                                            value={matriculaData.status}
                                            onChange={handleInputChange}
                                            className="form-control"
                                            required
                                        >
                                            <option value="ativo">Ativo</option>
                                            <option value="cancelado">Cancelado</option>
                                            <option value="trancado">Trancado</option>
                                            <option value="concluido">Concluído</option>
                                        </select>
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="modoCurso">Modo do Curso:</label>
                                        <select
                                            id="modoCurso"
                                            name="modoCurso"
                                            value={matriculaData.modoCurso}
                                            onChange={(e) => {
                                                const novoModo = e.target.value;
                                                const novoTipo = novoModo === "Mensalidade" ? "mensalidade" : "parcelado";
                                                
                                                setMatriculaData(prev => ({
                                                    ...prev,
                                                    modoCurso: novoModo,
                                                    tipoPagamento: novoTipo,
                                                    // Limpa campos específicos se mudar o tipo
                                                    numeroParcelas: novoTipo === "mensalidade" ? "" : prev.numeroParcelas,
                                                    valorParcela: novoTipo === "mensalidade" ? "" : prev.valorParcela,
                                                    valorMensalidade: novoTipo === "parcelado" ? "" : prev.valorMensalidade
                                                }));

                                                if (novoTipo === "mensalidade") {
                                                    clearFieldError("numeroParcelas");
                                                }
                                            }}
                                            className="form-control"
                                        >
                                            <option value="60h">Parcelado 60h</option>
                                            <option value="80h">Parcelado 80h</option>
                                            <option value="Mensalidade">Mensalidade</option>
                                        </select>
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="valorCurso">
                                            {matriculaData.tipoPagamento === "mensalidade" ? "Valor Mensalidade:" : "Valor do Curso:"}
                                        </label>
                                        <input
                                            type="text"
                                            id="valorCurso"
                                            name="valorCurso"
                                            value={matriculaData.valorCurso}
                                            onChange={(e) => {
                                                const nextValue = e.target.value;

                                                setMatriculaData({
                                                    ...matriculaData,
                                                    valorCurso: nextValue,
                                                });

                                                if (Number.isFinite(parseValorMonetario(nextValue)) && parseValorMonetario(nextValue) > 0) {
                                                    clearFieldError("valorCurso");
                                                }
                                            }}
                                            inputMode="decimal"
                                            className={getFieldClassName("valorCurso")}
                                            placeholder={matriculaData.tipoPagamento === "mensalidade" ? "Valor Mensalidade" : "Valor do Curso"}
                                            required
                                        />
                                        {fieldErrors.valorCurso && (
                                            <div className="invalid-feedback d-block">{fieldErrors.valorCurso}</div>
                                        )}
                                    </Col>
                                    {matriculaData.tipoPagamento === "parcelado" && (
                                        <Col md={12}>
                                            <label htmlFor="numeroParcelas">Número de Parcelas:</label>
                                            <select
                                                id="numeroParcelas"
                                                name="numeroParcelas"
                                                value={matriculaData.numeroParcelas || ''}
                                                onChange={handleNumeroParcelasChange}
                                                className={getFieldClassName("numeroParcelas")}
                                                disabled={!matriculaData.valorCurso}
                                                required
                                            >
                                                <option value="">Selecione o número de parcelas</option>
                                                {[...Array(13)].map((_, i) => (
                                                    <option key={i + 1} value={i + 1}>
                                                        {i + 1}x
                                                    </option>
                                                ))}
                                            </select>
                                            {fieldErrors.numeroParcelas && (
                                                <div className="invalid-feedback d-block">{fieldErrors.numeroParcelas}</div>
                                            )}
                                        </Col>
                                    )}
                                    
                                    <Col md={12}>
                                        <label htmlFor="primeiraParcela">Primeira Parcela:</label>
                                        <InputMask
                                            mask="99/99/9999"
                                            id="primeiraParcela"
                                            name="primeiraParcela"
                                            value={matriculaData.primeiraDataPagamento || ""}
                                            onChange={(e) => {
                                                const nextValue = e.target.value;

                                                setMatriculaData({
                                                    ...matriculaData,
                                                    primeiraDataPagamento: nextValue,
                                                });

                                                if (formatarDataParaEnvio(nextValue)) {
                                                    clearFieldError("primeiraParcela");
                                                }
                                            }}
                                            className={getFieldClassName("primeiraParcela")}
                                            style={getFieldStyle("primeiraParcela")}
                                            placeholder="dd/mm/aaaa"
                                            required
                                        />
                                        {fieldErrors.primeiraParcela && (
                                            <div className="invalid-feedback d-block">{fieldErrors.primeiraParcela}</div>
                                        )}
                                    </Col>
                                    {matriculaData.tipoPagamento === "parcelado" && (
                                        <Col md={12}>
                                            <label htmlFor="valorParcela">Valor da Parcela:</label>
                                            <input
                                                type="text"
                                                id="valorParcela"
                                                name="valorParcela"
                                                value={formatarValorMonetario(matriculaData.valorParcela)}
                                                className="form-control"
                                                placeholder="Valor da Parcela"
                                                readOnly
                                            />
                                        </Col>
                                    )}
                                </Row>
                            </div>
                        </div>
                        <div className="card mb-3 mt-4">
                            <div className="card-header">
                                <h6 className="card-title mb-0">Dados do Responsável</h6>
                            </div>

                            <div className="card-body">
                                <Col md={12}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            id="showParentFields"
                                            name="showParentFields"
                                            checked={showParentFields}
                                            onChange={handleParentDataChange}
                                            className="form-check-input"
                                        /> Aluno menor de 18 anos
                                    </label>
                                </Col>

                                {showParentFields && (
                                    <div className="card mt-3">
                                        {/* <div className="card-header">
                                        <h6 className="card-title mb-0">Dados do Responsável</h6>
                                    </div> */}
                                        <Row className="gy-3">
                                            <Col md={6}>
                                                <label htmlFor="nomePai">Nome do Pai:</label>
                                                <input
                                                    type="text"
                                                    id="nomePai"
                                                    name="nomePai"
                                                    value={matriculaData.nomePai || ''}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                    placeholder="Nome do pai/responsável"
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <label htmlFor="contatoPai">Contato do Pai:</label>
                                                <InputMask
                                                    type="text"
                                                    id="contatoPai"
                                                    name="contatoPai"
                                                    mask="(99) 99999-9999"
                                                    value={matriculaData.contatoPai || ''}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                    placeholder="Contato do pai/responsável"
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <label htmlFor="nomeMae">Nome da Mãe:</label>
                                                <input
                                                    type="text"
                                                    id="nomeMae"
                                                    name="nomeMae"
                                                    value={matriculaData.nomeMae || ''}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                    placeholder="Nome da mãe/responsável"
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <label htmlFor="contatoMae">Contato da Mãe:</label>
                                                <InputMask
                                                    type="text"
                                                    id="contatoMae"
                                                    name="contatoMae"
                                                    mask="(99) 99999-9999"
                                                    value={matriculaData.contatoMae || ''}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                    placeholder="Contato da mãe/responsável"
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                )}

                            </div>
                        </div>
                    </Col>
                </Row>

                <div className="text-center mt-4">
                    <button type="button" className="btn btn-outline-secondary me-2" onClick={goBack}>
                        Voltar
                    </button>
                    <button type="button" className="btn btn-primary me-2" onClick={abrirModalConfirmacao}>
                        {matriculaId ? 'Atualizar Matrícula' : 'Cadastrar Matrícula'}
                    </button>

                </div>
            </form>
            <Modal show={showUserSearchModal} onHide={closeUserSearchModal} centered animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Pesquisar Usuário</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <input
                        type="text"
                        id="usuarioSearch"
                        name="usuarioSearch"
                        onChange={handleUsuarioSearch}
                        className="form-control"
                        placeholder="Digite para pesquisar"
                        ref={inputSearchRef}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && filteredUsuarios.length > 0) {
                                handleUsuarioSelect(filteredUsuarios[0]); // Seleciona o primeiro da lista
                                closeUserSearchModal(); // Fecha o modal
                            }
                        }}
                    />
                    <ul className="list-group mt-2">
                        {filteredUsuarios.length > 0 ? (
                            filteredUsuarios.map((usuario) => (
                                <li
                                    key={usuario.cp_id}
                                    className="list-group-item list-group-item-action"
                                    onClick={() => {
                                        handleUsuarioSelect(usuario);
                                        closeUserSearchModal();
                                    }}
                                    style={{ cursor: "pointer" }}
                                >
                                    {usuario.cp_nome} - {usuario.cp_cpf}
                                </li>
                            ))
                        ) : (
                            <li className="list-group-item">Nenhum usuário encontrado</li>
                        )}
                    </ul>
                </Modal.Body>
            </Modal>
            <Modal show={showPaymentChangeModal} onHide={() => setShowPaymentChangeModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Mudança de Tipo de Pagamento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Você está alterando de <strong>{matriculaData.tipoPagamento === "parcelado" ? "Parcelado" : "Mensalidade"}</strong> para <strong>{pendingPaymentType === "parcelado" ? "Parcelado" : "Mensalidade"}</strong>.</p>
                    <p>Esta ação irá:</p>
                    <ul>
                        {pendingPaymentType === "mensalidade" ? (
                            <>
                                <li>Alterar o sistema de cobrança de parcelas fixas para mensalidades</li>
                                <li>O valor será tratado como mensalidade fixa</li>
                                <li>As configurações de parcelas serão removidas</li>
                            </>
                        ) : (
                            <>
                                <li>Alterar o sistema de cobrança de mensalidades para parcelas fixas</li>
                                <li>O valor será dividido em parcelas</li>
                                <li>Será necessário configurar o número de parcelas</li>
                            </>
                        )}
                    </ul>
                    <p>Deseja continuar com esta alteração?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        setShowPaymentChangeModal(false);
                        setPendingPaymentType("");
                    }}>
                        Cancelar
                    </Button>
                    <Button variant="warning" onClick={() => {
                        setMatriculaData({
                            ...matriculaData,
                            tipoPagamento: pendingPaymentType,
                            numeroParcelas: "",
                            valorParcela: 0,
                        });
                        setShowPaymentChangeModal(false);
                        setPendingPaymentType("");
                        toast.success(`Tipo de pagamento alterado para ${pendingPaymentType === "parcelado" ? "Parcelado" : "Mensalidade"}`);
                    }}>
                        Confirmar Alteração
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showConfirmModal} onHide={fecharModalConfirmacao} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmação</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Tem certeza que deseja {matriculaId ? "atualizar" : "cadastrar"} esta matrícula?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={fecharModalConfirmacao}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={(e) => {
                        fecharModalConfirmacao();
                        handleSubmit(e);
                    }}>
                        Confirmar
                    </Button>


                </Modal.Footer>
            </Modal>

        </div>
    );


};

export default CadastroMatricula;
